import React, { useState } from 'react';
import { Card, Row, Col, Form, Spinner, Button } from 'react-bootstrap';
import Chart from 'react-google-charts';
import axios from 'axios';

export default function SiteAnnualProgrammingReport() {

    const PERFORMANCE_BASE_URL = process.env.REACT_APP_PERFORMANCE_BASE_URL;

    const PERFORMANCE_SEARCH = process.env.REACT_APP_PERFORMANCE_SEARCH;
    const [performanceData, setPerformanceData] = useState([]);
    const visitData = {
        siteName: "",
        year: "",
        month: "",
        status: "APPROVED"
    }


    const [spinner, setSpinner] = useState(false);

    const handleSiteChange = (e) => {
        console.log(e.target.value);
        visitData.siteName = e.target.value;
        const performanceAPI = PERFORMANCE_BASE_URL + PERFORMANCE_SEARCH;
        console.log('Performance api ' + performanceAPI)
        setSpinner(true);
        if (performanceAPI) {
            const fetchdata = async () => {
                try {
                    const response = await axios.post(performanceAPI, visitData)
                    setPerformanceData(response.data);
                } catch (error) {
                    console.error(error)
                } finally {
                    setSpinner(false);
                }
            };
            fetchdata();
        }
    };

    const getPerformanceData = (performanceData) => {
        const siteFiscalData = {};
        const resultArray = [];
        console.log(performanceData);
        const perfData = performanceData.filter(e => e.status === 'APPROVED');
        console.log(`perfData:${perfData}`);
        perfData.forEach(entry => {
            const { performanceData, fiscalYear } = entry;
            console.log(`perf:fiscalyear=${fiscalYear}`);

            if (fiscalYear) {
                if (!siteFiscalData[fiscalYear]) {
                    siteFiscalData[fiscalYear] = [];
                }
                performanceData.map((item, index) => {

                    siteFiscalData[fiscalYear].push({

                        programName: item.qualitative.programName,
                        programDate: item.qualitative.programDate,
                        attendees: item.quantitative.attendance,
                        netRevenue: item.netRevenue,
                        programCategory: item.qualitative.programCategory,
                        programType: item.qualitative.programType,
                        targetAudiences: item.quantitative.targetAudiences,
                        virtualOrInPerson: item.quantitative.virtualOrInPerson,
                        onsiteOrOffsite: item.quantitative.onsiteOrOffsite
                    });
                });
            }
        });

        console.log(siteFiscalData);

        const years = Object.keys(siteFiscalData).sort();
        console.log(`years:${years}, perf:${years[0]}`);
        // table data
        years.forEach(year => {
            const fyYears = `FY${year}/${year % 100 + 1}`;
            resultArray.push(['Year', 'Program Name', 'Date', 'Attendees', 'Net Revenue', 'Category', 'Type', 'Target Audience', 'In-Person/Virtual', 'On-Site/Off-Site']);
            // Object.entries(siteFiscalData[year]).forEach(item => {
            //     resultArray.push([fyYears, ...Object.values(siteFiscalData[year][item])]);
            // })
            resultArray.push([fyYears, ...Object.values(siteFiscalData[year][0])]);

        });
        return resultArray;
    }
    const annualProgrammingReport = getPerformanceData(performanceData);
    console.log('annualProgrammingReport:' + annualProgrammingReport);

    const annualProgrammingFormatters = [
        {
            type: "ArrowFormat",
            column: 1,
        },
    ];

    const downloadCSV = () => {
        const combinedData = [
            ['Annual Programming Report'],
            ...annualProgrammingReport.map(row => row.join(',')),

        ];

        // Convert the chart data to CSV format
        const csvContent = combinedData.join('\n');
        // Create a data URI for the CSV content
        const encodedUri = encodeURI('data:text/csv;charset=utf-8,' + csvContent);
        // Create a download link
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'SiteAnnualProgrammingReport.csv');
        // Append the link to the document body and trigger the click event
        document.body.appendChild(link);
        link.click();
    };
    const createDownloadHandler = () => {
        return () => downloadCSV();
    };

    return (
        <>
            <span ><b>Site Annual Programming Report </b> </span>
            {performanceData.length > 0 &&
                <Row className="mb-0 main-content" >
                    <Col>
                        <Button onClick={createDownloadHandler()}>Download Data</Button>
                    </Col>
                    <Col />
                    <Col />
                    <Col />
                </Row>
            }
            <Row className="mb-0 main-content" >
                <Col>
                    <Card>
                        <Card.Body>
                            <Form>
                                <Row className="mb-0 main-content" >
                                    <Form.Group as={Col} >
                                        <Form.Label>Select Site Name </Form.Label>
                                        {/* value={formData.siteName} onChange={handleInputChange} */}
                                        <Form.Select defaultValue="" name="siteName" required onChange={handleSiteChange}>
                                            <option value="">Select</option>
                                            <option>ANTHRACITE HERITAGE</option>
                                            <option>BRANDYWINE BATTLEFIELD</option>
                                            <option>BUSHY </option>
                                            <option>CONRAD W</option>
                                            <option>CORNWALL</option>
                                            <option>DANIEL B</option>
                                            <option>DRAKE WELL</option>
                                            <option>ECKLEY MINERS' VLGE</option>
                                            <option>EPHRATA CLOISTER</option>
                                            <option>ERIE MARITIME</option>
                                            <option>FORT PITT</option>
                                            <option>GRAEME </option>
                                            <option>HOPE</option>
                                            <option>JOSEPH P</option>
                                            <option>LANDIS VALLEY</option>
                                            <option>OLD ECONOMY</option>
                                            <option>PENNSBURY</option>
                                            <option>PA LUMBER MUSEUM</option>
                                            <option>PA MILITARY MUSEUM</option>
                                            <option>RAILROAD MUSEUM</option>
                                            <option>SOMERSET</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formYear">

                                    </Form.Group>
                                    <Col />
                                </Row>
                            </Form>

                        </Card.Body>


                    </Card>
                </Col>

            </Row>
            {spinner && <Spinner />}
            < Row className="mb-0 main-content" >
                {performanceData[0] ?
                    <Col>
                        <Card>
                            <Card.Title> Annual Programming Report</Card.Title>
                            <Card.Body>

                                <Chart
                                    width={'100%'}
                                    height={'100%'}
                                    chartType="Table"
                                    loader={<div>Loading Chart</div>}
                                    data={annualProgrammingReport}
                                    formatters={annualProgrammingFormatters}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                    : <>No data found!</>
                }
            </Row >
        </>
    );
}